<template>
	<div class="agreement">
		<!-- 登入-协议 -->
		<div class="cut_off"></div>
		<div class="agreement_box">
			<!-- 1 -->
			<div class="agreement_content" v-if="this.$store.state.agreement == '0'" >
				<div class="content_title">
					<h1>使用協議</h1>
					<div class="title_back"></div>
				</div>
				<p>歡迎使用台易購支付商家平台，爲了保障您的權益，請先閱讀《台易購支付商家管理系統使用協議》</p>
				<el-checkbox class="agreement_checkbox" v-model="checked">我已閱讀並同意<span class="agreement_checked">《台易購支付商家管理系統使用協議》</span></el-checkbox>
				<div class="button_box">
					<el-button class="agreement_button" :plain="false" type="primary" @click="agreementClick()">進入商家平台系統</el-button>
					<!-- <div class="checked_text">{{checked?checkedTText:checkedFText}}</div> -->
				</div>
				<!-- 01-agreement_content -->
			</div>
			<!-- 2 -->
			<div v-if="this.$store.state.agreement != '0'">
				<div class="safety_content">
					<div class="content_title">
						<h1>設定安全資訊</h1>
						<div class="safety_back"></div>
					</div>
					<p class="safety_text1">
						設定個人化預留資訊，將顯示在首頁、儲值頁面，提領頁面這三處，如您設定完成後，在該三處頁面任壹處卻未看到您設定的預留資訊，您可能正在浏覽假冒網站，請立即停止操作，並修改密碼以策安全。
					</p>
					<p class="safety_text2">預留資訊設定內容可以在個人中心中進行更改。</p>
					<div class="safety_box" v-show="safetyTF">
						<div>
							預留資訊：
							<el-input :disabled="reservedTF" v-model="informationVal" class="information" maxlength="10" clearable
							 placeholder="例：我愛台易購。最多10個字符" @blur="informationValJudge()">
							</el-input>
							<span class="hint_text" v-show="informationHintTF"> <i class="el-icon-error"></i>{{informationHint}}</span>
						</div>
						<div>
							交易密碼：
							<el-input :disabled="reservedTF" v-model="passVal" class="pass" show-password maxlength="6" placeholder="6位數字，不允許數字以外任何字元字符"
							 @blur="passValJudge()">
							</el-input>
							<span class="hint_text" v-show="passHintTF"> <i class="el-icon-error"></i>{{passHint}}</span>
						</div>
					</div>
					<div class="googole" @click="goLoginag()">
						<p>您尚未綁定Google驗證器，請點擊此處綁定</p>
					</div>
					<!-- 02-agreement_content -->
				</div>
				<div class="safety_button">
					<el-button @click="goLogin()">暫不設定</el-button>
					<el-button @click="submitForm()" type="primary">確定設定</el-button>
				</div>
			</div>
			<!-- agreement_box -->
		</div>
	</div>
</template>

<script>
	import axios from 'axios';

	export default {
		name: 'Agreement',
		props: {},
		data() {
			return {
				agreementShow: false,
				checked: true,
				ShowSucc: false,
				ShowError: false,
				reservedTF: false,
				safetyTF: true,
				remind: '交易密碼格式有誤',
				// checkedFText: "您尚未確認已閱讀並同意使用協議",
				// checkedTText: "您已經確認已閱讀並同意使用協議",
				informationVal: '',
				informationHint: '請設定預留資訊',
				informationHintTF: false,
				informationHintSucc: false,
				passHint: '請設定交易密碼',
				passHintTF: false,
				passHintSucc: false,
				passVal: '',
				setNextTF: false,
			}
		},
		computed: {
		},
		components: {

		},
		methods: {
			agreementClick() {
				if (!this.checked) {
					this.$message({
						showClose: true,
						message: '您尚未確認已閱讀並同意使用協議',
						type: 'warning',
						duration: 1000
					});
				} else {
					this.axiosAgreement();
					this.changeAgreement('1');
				}
			},
			// FUN-全局-修改-第一次登入
			changeAgreement(agreement){
				this.$store.commit('changeAgreement',agreement);
			},
			// 更新第一次登入
			axiosAgreement() {
				axios.get(this.$store.state.axiosUseStatusUpdateUrl, {
					params: {
						uid: this.$store.state.uid
					}
				}).then((res) => {
					// console.log(res);
				})
			},
			//判斷預留資詢
			informationValJudge() {
				if (this.informationVal == '') {
					this.informationHintSucc = false;
					this.informationHintTF = true;
					this.informationHint = '請設定預留資訊';
					return
				} else {
					this.informationHintSucc = true;
					this.informationHintTF = false;
				}
				// var patt = /[\u4E00-\u9FA5]/;
				// if(!patt.test(this.informationVal)){
				//   this.informationHintSucc = false;
				//   this.informationHintTF = true;
				//   this.informationHint = '預留資訊格式有誤';
				// } else {
				//   this.informationHintSucc = true;
				//   this.informationHintTF = false;
				// }
			},
			//判斷交易密碼
			passValJudge() {
				if (this.passVal == '') {
					this.passHintSucc = false;
					this.passHintTF = true;
					this.passHint = '請設定交易密碼';
					return
				}
				var pattern = /\d{6}/;
				if (!pattern.test(this.passVal)) {
					this.passHintSucc = false;
					this.passHintTF = true;
					this.passHint = '交易密碼必須6位數字';
					return
				} else {
					this.passHintSucc = true;
					this.passHintTF = false;
				}
			},
			goLogin() {
				// console.log(this.$store.state.settledTF);
				if( this.$store.state.settledTF == '0' ){
					// 去设置：
					this.$router.push("/setwithdraw");
				} else {
					// 登入后首页：
					this.$router.push("/login");
				}
				
			},
			// 谷歌驗證碼綁定
			goLoginag() {
				this.$router.push("/login/account/bindings")
			},
			nogologina(){
				this.setNextTF=true
			},
			// FUN
			submitForm() {
				if (!this.reservedTF) {
					this.informationValJudge();
					this.passValJudge();
					let submit = this.informationHintSucc & this.passHintSucc;
					if (submit) {
						axios.get(this.$store.state.axiossubmitForm, {
							params: {
								trader_password: this.passVal,
								reserved: this.informationVal,
								action: 1,
								uid: this.$store.state.uid
							}
						}).then((res) => {
							// console.log(res.data);
							// 修改失敗
							if (res.data.status) {
								// this.$router.push("/login");
								if( this.$store.state.settledTF == '0' ){
									// 去设置：
									this.$router.push("/setwithdraw");
								} else {
									// 登入后首页：
									this.$router.push("/login");
								}
							} else {
								this.$message({
									showClose: true,
									message: '未知錯誤，請聯絡網站管理員了解詳情',
									type: 'error',
									duration: 1000
								});
							}

						})
					}

				} else {
					// this.$router.push("/login");
					
					if( this.$store.state.settledTF == '0' ){
						// 去设置：
						this.$router.push("/setwithdraw");
					} else {
						// 登入后首页：
						this.$router.push("/login");
					}
				}
			},

		},
		created(){
			if (this.$store.state.reserved) {
				this.safetyTF = false;
				this.reservedTF = true;
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* <!--未绑定谷歌验证器时显示--> */
	.agreement_box {
		height: 500px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.right_new h2{
		font-size: 32px;
		color: #7c9cec;
		float: left;
		padding-bottom: 4px;
		border-bottom: 2px solid #7C9CEC;
	}
	.button_stend {
		padding-top: 100px;
		padding-bottom: 25px;
		margin-left: 40px;
		
	}
	.right_new{
		float: right;
	}
	.right_new img{
		float: left;
	}
	.safety_box.button_stend>div{
		margin-left: 0px;
		margin-right: 0px;
	}

	
	.button_stend button {
		color: #7C9CEC;
	  background-color: #FFFFFF;
		height: 32px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 100px;
		font-weight: 700;
	}
	.el-button:focus, .el-button:hover{
		border-color: #DCDFE6;
	
	}
	/* 分割线 */
 .list_bock .z_index{
	  position: absolute;
    left: 24%;
    top: 11%;
    margin-left:0px;
    width: 800px;
    overflow: hidden;
    z-index: 10;
    border: 1px solid #5c595e;
		background-color: #ffffff;
 }
	.cut_off {
		height: 4px;
		background: #e73262;
	}

	.agreement_content {
		box-sizing: border-box;
		width: 768px;
		border: 2px solid #bbbbbb;
		margin: 0 auto;
		margin-top: 45px;
		margin-bottom: 45px;
		padding: 37px 46px;
		padding-bottom: 0px;
		color: #777777;
		overflow: hidden;
	}

	.agreement_content>p {
		margin: 29px 40px;
		line-height: 42px;
	}

	.content_title {
		box-sizing: border-box;
		font-size: 21px;
		font-weight: bold;
		position: relative;
		margin-left: 40px;
	}

	.agreement_checkbox {
		margin-left: 40px;
	}

	.title_back {
		width: 90px;
		height: 25px;
		background: #f2f2f2;
		position: absolute;
		top: 5px;
		z-index: -1;
	}

	.safety_back {
		width: 138px;
		height: 25px;
		background: #f2f2f2;
		position: absolute;
		top: 5px;
		z-index: -1;
	}

	.agreement_checked {
		color: #e73262;
		padding-bottom: 4px;
		border-bottom: 1px solid;
	}

	.button_box {
		box-sizing: border-box;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.agreement_button {
		margin: 40px 0;
	}

	.checked_text {
		color: #e73262;
		margin-top: 16px;
	}

	/* 2 */
	.safety_content {
		box-sizing: border-box;
		width: 768px;
		border: 2px solid #bbbbbb;
		margin: 0 auto;
		margin-top: 45px;
		margin-bottom: 45px;
		padding: 37px 46px;
		padding-bottom: 0px;
		color: #777777;
		overflow: hidden;
	}

	.safety_content .safety_text1 {
		margin: 0 40px;
		margin-top: 24px;
		line-height: 21px;
	}

	.safety_content .safety_text2 {
		margin: 0;
		margin-bottom: 27px;
		margin-left: 40px;
		line-height: 21px;
	}

	.safety_box>div {
		margin: 13px 40px;
	}

	.safety_box .information,
	.safety_box .pass {
		width: 300px;
	}

	.googole {
		color: #9db3f0;
		margin-left: 40px;
		margin-top: 20px;
		margin-bottom: 40px;
	}

	.googole>p {
		cursor: pointer;
		padding-bottom: 4px;
		width: 250px;
		border-bottom: 1px solid;
	}

	.safety_button {
		display: flex;
		justify-content: space-around;
		align-items: center;
		width: 300px;
		margin: 0 auto;
		margin-bottom: 30px;
	}

	/* 提示 */
	.hint_text {
		color: #e73262;
	}

	.hint_text i {
		margin: 0 4px;
	}
</style>
